import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EnvTranslatePipe } from './env-translate.pipe';

@Pipe({ name: 'translateSupportLink' })
export class TranslateSupportLinkPipe implements PipeTransform {
  private translateService = inject(TranslateService);
  private envTranslatePipe = inject(EnvTranslatePipe);

  transform(label: string, isNewClient: boolean): string {
    const supportUrlLabel = isNewClient ? 'global.support.link.newClient' : 'global.support.link.tariffChange';
    const supportUrl = this.envTranslatePipe.transform(supportUrlLabel);

    return this.translateService.instant(label, { supportUrl });
  }
}
